export default "__VITE_ASSET__CIE_JPVn__"